module.exports = __webpack_public_path__ + "image/qr-code.1782790484418.jpg";